import { Logger } from "_core_framework/logger";
import { hasSessionStorage } from "shared_critical/helper";
import { partial, isString } from "underscore";

MOVE.SRP.SessionStorage = function(SRP) {

  var isAvailable = hasSessionStorage();

  var _silent = function(fn) {
    var result;
    try {
      result = fn.call();
    } catch (e) {
      Logger.debug(e);
    }
    return result;
  };

  // these helper methods let us store simple collections in local storage
  var parse = function(str) {
    return _silent(partial(JSON.parse, str)) || str;
  };

  var stringify = function(val) {
    return isString(val) ? val : JSON.stringify(val);
  };

  var setItem = function(key, value) {
    if (isAvailable) {
      window.sessionStorage.setItem(key, stringify(value));
      return value;
    }
  };

  var getItem = function(key) {
    if (isAvailable) {
      return parse(window.sessionStorage.getItem(key));
    }
  };

  var mapItem = function(key, mapper) {
    return setItem(key, mapper(getItem(key)));
  };

  var withKey = function(key) {
    return {
      setItem: partial(setItem, key),
      getItem: partial(getItem, key),
      mapItem: partial(mapItem, key)
    };
  };

  SRP.SessionStorage = {
    setItem: setItem,
    getItem: getItem,
    mapItem: mapItem,
    withKey: withKey
  };

  return SRP.SessionStorage;

}(MOVE.SRP || {});



// WEBPACK FOOTER //
// ./srp/critical_components/_session_storage.js